<!---设备列表--->
<template>
    <div class="page_content">
        <div class="main">
            <!-- 表格 -->
            <div class="head">
                <!-- 搜索区域 -->
                <div class="searchArea">
                    <div class="title">查询数据</div>
                    <div class="content">
                        <el-form style="width: 90%"  label-width="90px">
                            <el-row :gutter="24">
                                <el-col :span="10">
                                    <el-form-item label="设备所在：">
                                        <el-select v-model="searchParams.province" placeholder="请选择" size="small" @change="handleProvinceChange" clearable>
                                            <el-option v-for="(item,index) in provinceData"
                                            :key="index"
                                            :label="item.regionname"
                                            :value="item.regionname"></el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="7">
                                    <el-form-item  class="deviceLocation">
                                        <el-select v-model="searchParams.city" placeholder="请选择" size="small" @change="handleCityChange" clearable>
                                           <el-option v-for="(item,index) in cityList"
                                            :key="index"
                                            :label="item.regionname"
                                            :value="item.regionname"></el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="7">
                                    <el-form-item class="deviceLocation">
                                        <el-select v-model="searchParams.town" placeholder="请选择" size="small" @change="handleTownChange" clearable>
                                            <el-option v-for="(item,index) in areasList"
                                            :key="index"
                                            :label="item.regionname"
                                            :value="item.regionname"></el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row :gutter="24">
                                <el-col :span="12">
                                    <el-form-item label="设备类型：">
                                    <el-select v-model="searchParams.dtype" placeholder="请选择" size="small" clearable>
                                        <el-option v-for="(item,index) in deviceTypeList"
                                        :key="index"
                                        :label="item.name"
                                        :value="item.id"
                                        ></el-option>
                                    </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item label="设备状态：">
                                    <el-select v-model="searchParams.state" placeholder="请选择" size="small" clearable>
                                        <el-option
                                        v-for="(item,index) in deviceState"
                                        :key="index"
                                        :label="item.label" :value="item.label"></el-option>
                                    </el-select>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                        </el-form>
                        <div class="block"></div>
                        <div class="rightBtn">
                            <el-button type="primary" icon="el-icon-search" size="small" class="btnStyle" style="margin-bottom:0.1rem" @click="onSearch">查询</el-button>
                            <el-button icon="el-icon-refresh-left" size="small" style="margin-left: 0;" @click="resetting">重置</el-button>
                        </div>
                    </div>
                </div>
            </div>
            <!-- 表格区域 -->
            <div class="tableArea">
                <!-- 操作区域 -->
                <div class="option">
                    <div>
                        <el-input placeholder="请输入名称/设备序号" style="width: 5rem;" size="small" v-model="searchParams.code" clearable >
                            <i slot="prefix" class="el-input__icon el-icon-search"></i>
                            <el-button type="primary" slot="append" @click="onSearch">搜索</el-button>
                        </el-input>
                    </div>
                    <div>
                        <el-button icon="el-icon-download" size="small" @click="downAll">多选下载</el-button>
                    </div>
                </div>
                <div class="showSelected" v-if="isShow">
                    <div>
                      <i class="el-icon-info"></i><span style="margin-left:0.1rem">已选择{{selectedRows.length}}台设备</span>
                    </div>
                    <div>
                      <!-- <el-button type="text" size="small">清空</el-button> -->
                    </div>
                </div>
                <div class="table">
                    <el-table :data="tableData" row-key="code" style="width: 100%"
                     :header-cell-style="{background:'#FAFAFA',color:'#405891'}"
                      @selection-change="handleSelectionChange">
                        <el-table-column type="selection" width="55" reserve-selection></el-table-column>
                        <el-table-column label="序号" width="80">
                        <template slot-scope="scope">
                            {{scope.$index+1}}
                        </template>
                        </el-table-column>
                        <el-table-column prop="name" label="监测点名称">
                        </el-table-column>
                        <el-table-column prop="dname" label="设备序号" width="160">
                        </el-table-column>
                        <el-table-column width="50">
                            <template slot-scope="scope">
                               <i v-if="scope.row.dname" class="el-icon-document-copy" style="cursor:pointer" @click="copyBtn(scope.row.dname)"></i>
                            </template>
                        </el-table-column>
                        <el-table-column prop="typename" label="设备类型">
                        </el-table-column>
                        <el-table-column prop="state" label="设备状态">
                            <template slot-scope="scope">
                                <div style="display:flex; align-items:center;">
                                    <span :style="{background:scope.row.state == '离线'? '#FF791A':'#75D391'}" style="display:inline-block;width:5px;height:5px;border-radius:50%;margin-right:0.1rem"></span>
                                    <span>{{scope.row.state}}</span>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column prop="address" label="位置">
                        </el-table-column>
                        <el-table-column label="操作" width="200" fixed="right">
                        <template slot-scope="scope">
                            <el-button style="color:#437EDE" type="text" @click="checkData(scope.row)">查看数据</el-button>
                            <el-button style="color:#437EDE" type="text" @click="download(scope.row)">下载</el-button>
                        </template>
                        </el-table-column>
                    </el-table>
                    <div style="margin-top:0.2rem;text-align:right;">
                        <a-pagination :current="page" :pageSize="limit" show-quick-jumper show-size-changer :page-size-options="pageSizeOptions" :total="totalCount" @change="onChange" @showSizeChange="pageSizeChange" />
                    </div>
                </div>
            </div>
        </div>

        <!-- 下载数据弹框 -->
        <DownFormModel :downloadShow="downloadShow"
                   :downData="downData"
                   :more = "all"
                   :moreCode = "moreCode"
                   :moreData = "selectedRows"
                   :params = "params"
                   @hideDownModal="hideDownModal" />
    </div>
</template>
<script>
import regionList from '@/assets/json/region.json'
import { getAreaList,getDeviceType } from '@/api/page/deviceList.js'
import DownFormModel from '@/components/dataCompare/children/downformModel'
import MixinSD from '@/store/sd/mixinsSd.js'
export default {
    mixins: [MixinSD],
    components: {
        DownFormModel
    },
    data() {
        return {
            regionList, // 省市区
            // 查询
            searchParams:{
               province:'不限',
               city:'不限',
               town: '不限',
               dtype: 'xxx',
               state: '全部',
               code: '',
            },
            // 设备状态
            deviceState:[{
                id:0,
                label:'全部'
            },{
                id:1,
                label: '在线'
            },{
                id:2,
                label: '离线'
            }],
            deviceTypeList:[],
            isShow: false, // 控制显示选择的数量
            provinceData:[],
            cityList:[],
            areasList:[],
            tableData:[],
            page: 1,
            limit: 10,
            totalCount: null,
            pageSizeOptions: ['10','20','30','40','50'],
            downloadShow: false,
            downData: '',
            all: false,
            moreCode: [],
            selectedRows: [], // 选中的行数据
            params: []
        }
    },
    created() {
       this.getDeviceParams();
       this.getArea();
       this.getTableList();
       this.getDeviceType();
    },
    mounted() {
    },
    methods:{
        // 获取省，市，区相关数据
        getArea () {
          let regionList = this.regionList.RECORDS;
          regionList.forEach(item=> {
            if(item.level == 1) {
                this.provinceData.push(item)
            }
          })
        },
        handleProvinceChange  (val) {
          this.searchParams.province = val
          this.searchParams.city = ""
          this.searchParams.town = ""
          this.cityList = []
          let code = ""
          this.regionList.RECORDS.forEach(item=> {
            if(item.regionname == val) {
                code = item.regioncode
            }
            if(item.level==2&&item.parentcode==code) {
                this.cityList.push(item)
            }
          })
        },
        handleCityChange  (val) {
          this.searchParams.city = val
          this.areasList = []
          let code = ""
          this.regionList.RECORDS.forEach(item=> {
            if(item.regionname == val) {
                code = item.regioncode
            }
            if(item.level==3&&item.parentcode==code) {
                this.areasList.push(item)
            }
          })
        },
        handleTownChange  (val) {
          this.searchParams.town = val
        },
        // 获取地区列表
        getTableList() {
          let self = this;
          let data = {
            account: window.localStorage.getItem('account'),
            is_all: 2,
            is_gkz: 2,
            page: self.page,
            limit: self.limit,
            dtype: self.searchParams.dtype == 'xxx'? '':self.searchParams.dtype,
            state: self.searchParams.state == '全部'? '':self.searchParams.state,
            code: self.searchParams.code,
            name: self.searchParams.code,
            merge_search:"code_name",
            province: self.searchParams.province == '不限'? '':self.searchParams.province,
            city: self.searchParams.city == '不限' ? '' : self.searchParams.city,
            town: self.searchParams.town == '不限' ? '' : self.searchParams.town,
            token: window.localStorage.getItem('token'),
            ts:this.stringTime(new Date())
          };
          getAreaList(data).then(res=> {
            self.tableData = res.data
            self.totalCount = res.meta.total_count
            const result = res.data;
            self.tableData = result.filter(item => {
                return item.code !== null && item.type !== '17'
            })
            self.tableData.forEach((item, i) => {
                item.key = i
                item.id = i < 9 ? '0' + (i + 1) : i + 1
                item.time = this.stringTime(new Date())
            })
          })
        },
        // 获取设备类型
        getDeviceType() {
           let data = {
                account: window.localStorage.getItem('account'),
                token: window.localStorage.getItem('token'),
                ts:this.stringTime(new Date())
           }
           getDeviceType(data).then(res=> {
               this.deviceTypeList = res.data
               this.deviceTypeList.unshift({
                  id: 'xxx',
                  name:'全部'
               })
           })
        },
        // 表格-查看数据
        checkData(data) {
            this.$router.push({ path: 'DataPage', query: { param: JSON.stringify(data) } })
        },
        // 表格-下载数据
        download(data) {
            this.all = false
            this.downData = data
            this.downloadShow = true
        },
        // 表格-批量下载
        downAll() {
            if (!this.moreCode.length) {
                this.$message.warning('未选择设备')
            } else {
                this.all = true
                this.downloadShow = true
            }
        },
        // 关闭-下载弹框
        hideDownModal (val) {
            this.downloadShow = false
        },
        onChange(val) {
            this.page = val
            this.getTableList()
        },
        pageSizeChange(page,pageSize) {
            this.page = 1
            this.limit = pageSize
            this.getTableList()
        },
        onSearch() {
            this.page = 1
            this.limit = 10
            this.getTableList()
        },
        resetting() {
          this.searchParams = {
            province:'不限',
            city:'不限',
            town: '不限',
            dtype: 'xxx',
            state: '全部',
            code: '',
          }
          this.getTableList()
        },
        getDeviceParams () { // 获取用户设备接收参数
            var ts = this.stringTime(new Date())
            var data = {
                account: window.localStorage.getItem('account'),
                token: window.localStorage.getItem('token'),
                ts
            }
            const that = this
            this.getDeviceParamsSD(data).then(res=> {
                const result = res.data.data
                result.forEach(i=> {
                    this.params.push(i.name)
                })
            })
       },
        handleSelectionChange(selection) {
           this.selectedRows = selection
        },
    },
    watch: {
        selectedRows(val) {
            this.$nextTick(()=> {
               this.isShow = val.length>0 ? true: false
               this.moreCode = []
               val.forEach(item => {
                this.moreCode.push(item.code)
               })
            })
        },
    }

}
</script>
<style lang="less" scoped>
    // 搜索框
    ::v-deep .el-form-item {
        margin-bottom: 0.1rem;
        .el-form-item__label {
            color: #405891;
        }
    }
    ::v-deep .el-input-group__append, .el-input-group__prependtyle {
        background: #437ede;
        border-color: #437ede;
        color: #fff;
    }
    ::v-deep .el-select {
      width: 100%;
    }
    .deviceLocation ::v-deep .el-form-item__content {
        margin-left:0 !important;
    }
    .rightBtn {
        display: flex;
        flex-direction: column;
    }
</style>
